const applyInvoice = {
  path: 'applyInvoice',
  component: resolve => require(['../../../../components/pages/signUp/applyInvoice'], resolve)
}
export default applyInvoice
